import { where } from 'firebase/firestore';
import {
  fetchByTable,
  addDataToTableWithCustomId,
  updateDataById,
} from '../utils';

export const addUser = async (user, setLoading) =>
  addDataToTableWithCustomId({
    tableName: 'users',
    id: user.uid,
    data: user,
    setLoading,
  });
